module.exports = __webpack_public_path__ + "static/img/溶解仪.a6efbc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/仪器设备/溶解仪.png
// module id = dIDy
// module chunks = 16